// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3wC-3","gfeWrapper":"CalendarEvent_gfeWrapper__3jY08"};